import { Component, OnInit, Input } from '@angular/core';
import { SanitizeService } from 'src/app/services/sanitize.service';

@Component({
  selector: 'app-collapsable-list',
  templateUrl: './collapsable-list.component.html',
  styleUrls: ['./collapsable-list.component.scss']
})
export class CollapsableListComponent implements OnInit {
  constructor(
      public sanitizeService: SanitizeService
      ) {}
  @Input() items: any;
  public  listItems: any;

  ngOnInit() {
    this.listItems = Object.values(this.items).map((item: any) => ({ ...item, expanded: false }));
  }

  expand(index) {
    const status = this.listItems[index].expanded;
    this.listItems = this.listItems.map(item => ({ ...item, expanded: false }));
    this.listItems[index].expanded = !status;
  }
}
